"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filter = void 0;
/**
 * Performance optimized version of `Array.prototype.filter` method.
 *
 * Creates a new array with all elements that pass the test implemented by the provided function.
 * @see https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
 *
 * **Limitations against native implementation**:
 *
 * - **`callback` is invoked for all indexes of the array**,
 * (not only for indexes with assigned values like native filter implementation), see example.
 * - **Doesn't coerce returned value from a callback to `true` or `false`**,
 * the callback has to return a boolean value directly.
 * - Doesn't accept the `scope` as last argument.
 *
 * @param {Array} array - Input array.
 * @param {Function} callback - Predicate to test each element of the array.
 * Return true to keep the element, false otherwise.
 *
 * @return {Array} with filtered results.
 *
 * @example
 * import { filter } from '@24i/appstage-shared-perf-utils/dist/array';
 *
 * const array = ['spray', 'limit', 'elite', 'exuberant', 'destruction'];
 *
 * //const result = array.filter(word => word.length > 6); // slower native solution
 * const result = filter(array, word => word.length > 6);  // faster
 *
 * console.log(result);
 * // expected output: Array ["exuberant", "destruction"]
 *
 * @example
 * import { filter } from '@24i/appstage-shared-perf-utils/dist/array';
 *
 * const nativeResult = [1, 2, , undefined].filter(() => true);
 * console.log(nativeResult); // Array [1, 2, undefined]. Yes, empty value is missing here.
 *
 * const customResult = filter([1, 2, , undefined], () => true);
 * console.log(customResult); // Array [1, 2, undefined, undefined]. With iteration over hole.
 */
const filter = (array, callback) => {
    const output = [];
    for (let i = 0, len = array.length; i < len; i++) {
        if (callback(array[i], i, array) === true) {
            output.push(array[i]);
        }
    }
    return output;
};
exports.filter = filter;
